import { htmlParse } from "@unisearch/helpers";
import React from "react";

import styles from "./hero.module.scss";

export const TeamHero = ({ title, designation, description, breadcrumbs }) => {
  return (
    <section className={styles.section_team_hero}>
      <div className="container">
        <div className={styles.wrapper}>
          {title && <h1 className={`${styles.title}`}>{htmlParse(title)}</h1>}
          {designation && (
            <div className={styles.designation}>{designation}</div>
          )}
          {breadcrumbs && (
            <div className={styles.breadcrumb}>{breadcrumbs}</div>
          )}
          {description && <div>{htmlParse(description)}</div>}
        </div>
      </div>
    </section>
  );
};

export default TeamHero;
